import React from 'react';
import { Form, FormGroup, Input, Label, List, ListGroup, ListGroupItem} from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import { ValuesList } from '../Components/layout/ReviewRow';
import { CONTROL_ACCESSORIES, AM_CATEGORIES } from './ConstAccessMethodsMock';
import { SELECTION_METHOD_BUTTONS, LOWTECH_SELECTION_METHOD_BUTTONS } from './ConstSelectionMethodBtns';
import { extractBodySiteButtons } from './ConstBodySiteBtns';
import { LABELS_FOR_SETUP } from './ConstForTestDriveSection';

const propTypes = {
  activeAccessMethodName: PropTypes.string,
  activeSetupSelectionMethod: PropTypes.string,
  activeSetupBodySite: PropTypes.arrayOf(PropTypes.string),
  activeSetupAccessories: PropTypes.arrayOf(PropTypes.string),
  activeSetupName: PropTypes.string,
};

const defaultProps = {
  activeAccessMethodName: '',
  activeSetupSelectionMethod: '',
  activeSetupBodySite: [],
  activeSetupAccessories: [],
  activeSetupName: '',
};

function TestDriveSetupSidebar(props) {
  const {
    activeAccessMethodName,
    activeSetupSelectionMethod,
    activeSetupBodySite,
    activeSetupAccessories,
    activeSetupName
  } = props;

  const bodySiteBtns = extractBodySiteButtons();
  //combine all the regular and low-tech selection buttons, but filter out any that have the same .value
  //https://stackoverflow.com/questions/1584370/how-to-merge-two-arrays-in-javascript-and-de-duplicate-items?rq=3
  var selMethodBtns = SELECTION_METHOD_BUTTONS.concat(LOWTECH_SELECTION_METHOD_BUTTONS.filter( ({value}) => !SELECTION_METHOD_BUTTONS.find(f => f.value === value) ));

  return (
    <>
    {/* <p className="aa-sidebar-heading">Setup</p> */}
    <ListGroupItem>Setup
      <ListGroup className="aa-setup-sidebar" flush>
        <ListGroupItem>{LABELS_FOR_SETUP.ACCESS_METHOD}
          <ValuesList 
            values={activeAccessMethodName} lookup={null} skipWarning
          />
        </ListGroupItem>
        <ListGroupItem>{LABELS_FOR_SETUP.SELECTION_METHOD}
          <ValuesList 
            values={activeSetupSelectionMethod} lookup={selMethodBtns} skipWarning
          />
        </ListGroupItem>
        <ListGroupItem>{LABELS_FOR_SETUP.BODY_SITES}
          <ValuesList 
            values={activeSetupBodySite} lookup={bodySiteBtns} skipWarning
          />
        </ListGroupItem>
        <ListGroupItem>{LABELS_FOR_SETUP.ACCESSORIES}
        <ValuesList 
            values={activeSetupAccessories} lookup={CONTROL_ACCESSORIES} skipWarning
          />
        </ListGroupItem>
        <ListGroupItem>{LABELS_FOR_SETUP.NAME}
        <ValuesList 
            values={activeSetupName} lookup={null} skipWarning
          />
        </ListGroupItem>
      </ListGroup>
    </ListGroupItem>
    </>
  );
}

TestDriveSetupSidebar.propTypes = propTypes;
TestDriveSetupSidebar.defaultProps = defaultProps;

export default TestDriveSetupSidebar;
